var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "20-home"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4891 1.35906C11.7967 1.14692 12.2034 1.14692 12.511 1.35906L20.1735 6.64358C21.0667 7.25956 21.6 8.27521 21.6 9.36018V19.5C21.6 21.3225 20.1226 22.7999 18.3 22.7999H5.70002C3.87749 22.7999 2.40002 21.3225 2.40002 19.5V9.36018C2.40002 8.27521 2.93334 7.25956 3.82651 6.64358L11.4891 1.35906ZM10.2 21H13.8V15.3C13.8 15.1343 13.6657 15 13.5 15H10.5C10.3343 15 10.2 15.1343 10.2 15.3V21ZM15.6 21V15.3C15.6 14.1402 14.6598 13.2 13.5 13.2H10.5C9.34023 13.2 8.40002 14.1402 8.40002 15.3V21H5.70002C4.8716 21 4.20002 20.3284 4.20002 19.5V9.36018C4.20002 8.86702 4.44244 8.40535 4.84842 8.12537L12 3.19323L19.1516 8.12537C19.5576 8.40535 19.8 8.86702 19.8 9.36018V19.5C19.8 20.3284 19.1285 21 18.3 21H15.6Z",
    fill: "#182BCF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.85d02c446945c33219b245c551fa8f9a.svg";
export { ForwardRef as ReactComponent };